import React from 'react';
import { Users, UserCheck, TrendingUp } from 'lucide-react';

const UsersTab = ({ dashboardStats }) => (
  <div className="p-6">
    <h2 className="text-2xl font-bold text-gray-800 mb-6">User Management</h2>
    <div className="bg-white rounded-lg shadow-md p-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="text-center p-4 bg-blue-50 rounded-lg">
          <Users className="h-8 w-8 text-blue-500 mx-auto mb-2" />
          <p className="text-2xl font-bold text-blue-600">{dashboardStats?.totalCustomers || 0}</p>
          <p className="text-sm text-gray-600">Total Customers</p>
        </div>
        <div className="text-center p-4 bg-green-50 rounded-lg">
          <UserCheck className="h-8 w-8 text-green-500 mx-auto mb-2" />
          <p className="text-2xl font-bold text-green-600">{dashboardStats?.totalCustomers || 0}</p>
          <p className="text-sm text-gray-600">Active Users</p>
        </div>
        <div className="text-center p-4 bg-purple-50 rounded-lg">
          <TrendingUp className="h-8 w-8 text-purple-500 mx-auto mb-2" />
          <p className="text-2xl font-bold text-purple-600">0</p>
          <p className="text-sm text-gray-600">New This Month</p>
        </div>
      </div>
    </div>
  </div>
);

export default UsersTab;
